import { HttpParams } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { DataResponse } from '@app/model/data-response.model';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CourseDTO } from 'src/app/model/courseDTO.model';
import { ModuleDTO } from 'src/app/model/moduleDTO.model';
import { CourseService } from 'src/app/services/api/course.service';
import { ModuleService } from 'src/app/services/api/module.service';
import { PaymentService } from 'src/app/services/payment.service';
import { fadeStaggerAnimation } from 'src/app/shared/constants/animations.const';

@Component({
    selector: 'app-dashboard-item-list',
    templateUrl: './dashboard-item-list.component.html',
    styleUrls: ['./dashboard-item-list.component.scss'],
    animations: [fadeStaggerAnimation],
    standalone: false
})
export class DashboardItemListComponent implements OnInit {
  @Input() public carouselConfig?: any;

  @Input()
  public set skipModule(value: boolean) {
    if (value !== undefined) {
      this._skipModule = value;
    }
  }

  public get skipModule() {
    return this._skipModule;
  }

  @Input() public set selectedId(value: string) {
    this._selectedId = value;
    this.resetPagination();
    this.fetchItems();
  }

  public get selectedId() {
    return this._selectedId;
  }

  public itemList: (ModuleDTO | CourseDTO)[] = [];
  public isLoading = true;
  public paymentEnabled = false;
  public pagination = {
    itemsPerPage: 10,
    currentPage: 1,
    totalItems: 0
  };

  private _skipModule: boolean;
  private _selectedId: string;

  constructor(
    private paymentService: PaymentService,
    private modulesService: ModuleService,
    private сourseService: CourseService
  ) {
  }

  ngOnInit() {
    this.paymentService.getPaymentConfig().subscribe(res => {
      this.paymentEnabled = !!res.enabled;
    });
  }
  
  public reachedBottom(): void {
    if (this.isLoading || this.pagination.totalItems <= this.itemList?.length) {
      return;
    }

    this.pagination.currentPage++;
    this.fetchItems();
  }

  private fetchItems() {
    this.isLoading = true;
    const params = new HttpParams()
      .set('sort', 'weight:ASC')
      .set('limit', this.pagination.itemsPerPage)
      .set('offset', (this.pagination.currentPage - 1) * this.pagination.itemsPerPage);

    const obs: Observable<any> = !this.skipModule ?
      this.modulesService.getModules(this.selectedId, params)
      : this.сourseService.getCourses(this.selectedId, params);

    obs
      .pipe(
        finalize(() => this.isLoading = false)
      )
      .subscribe((res: DataResponse<(ModuleDTO | CourseDTO)>) => {
        this.itemList = [...this.itemList, ...res.items];
        this.pagination.totalItems = res._meta.maxcount;
      });
  }
  
  private resetPagination(): void {
    this.pagination.currentPage = 1;
    this.pagination.totalItems = 0;
    this.itemList = [];
  }

}
